import React, { useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api } from "../lib/api";

export function ExportCsvButton({ path, fallbackName, label = "Exportar CSV", testid }) {
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(path, { responseType: "blob" });
      const name = /filename="([^"]+)"/.exec(res.headers["content-disposition"] || "")?.[1] || fallbackName;
      const url = URL.createObjectURL(res.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: name });
      document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
      toast.success(`${name} baixado.`);
    } catch (e) {
      toast.error("Não foi possível exportar o CSV.");
    } finally { setBusy(false); }
  };
  return (
    <button onClick={download} disabled={busy} data-testid={testid} className="inline-flex items-center gap-1.5 rounded-full border border-xmas-gold/30 px-3 py-1.5 text-xs text-xmas-snow transition hover:border-xmas-gold hover:text-xmas-gold disabled:opacity-50">
      <Download className="h-3.5 w-3.5" /> {busy ? "Gerando…" : label}
    </button>
  );
}
